
    var riot = require('riot')
    //src: starling/src/tags/waypoints-tab.html
riot.tag2('waypoints-tab',
  '<aside ref="main" class="side-tab"> <header class="side-tab_header"> <span class="side-tab_header_logo"> <i class="side-tab_header_icon material-icons">airplay</i> </span> <h3 class="side-tab_header_title">Slides</h3> <i class="side-tab_header_help side-tab_header_icon material-icons" onclick="{openWaypointsHelp}">help</i> <button if="{!canvas.isViewOnly()}" class="side-tab_header_menu floating-menu_button" onclick="{toggleTopMenu}"> <i class="material-icons floating-menu_button_icon">more_vert</i> </button> </header> <div ref="scrollList" class="side-tab_body" onwheel="{handleScroll}"> <p if="{waypointsZeroState}" class="side-tab_body_empty"> Use slides to make a walk-through presentation of your map. </p> <section show="{waypointsZeroState || cardsZeroState}" class="instruction"> <div show="{waypointsZeroState && !cardsZeroState}" class="populate-waypoints"> <button if="{!canvas.isViewOnly()}" ref="populateWaypoints" class="side-tab_action Button Button--Secondary Button--Plain Button--Full" onmouseenter="{highlightWaypointCandidates}" onmouseleave="{unHighlightWaypointCandidates}" onclick="{populateWaypoints}"> <svg class="Button__Icon"> <use xlink:href="#magic-wand-icon"></use> </svg> <span class="Button__Label">Add {cardCount()} {cardText()} to presentation</span> </button> </div> <div class="instruction-add-cards" show="{cardsZeroState}"> <span>Add some cards to your map first.</span> <span class="instruction-arrows"> <i class="fa fa-caret-right"></i> <i class="fa fa-caret-right"></i> <i class="fa fa-caret-right"></i> </span> </div> </section> <ul ref="waypointList" class="waypoint-list"> <li each="{waypoint, index in waypoints}" data-id="{waypoint.id}" id="waypoint-list_item--{waypoint.id}" class="side-tab_item" onclick="{() => chooseWaypointHandler({ waypointId: waypoint.id })}" ondblclick="{handleTitleDoubleClick.bind(null,waypoint.id)}" onmouseleave="{deselectWaypointsHandler.bind(this, waypoint.id)}" onmouseenter="{selectWaypointHandler.bind(this, waypoint.id)}"> <i if="{!canvas.isViewOnly()}" class="side-tab_item_drag-indicator material-icons">drag_indicator</i> <span class="side-tab_item_icon waypoint-list_item_index">{index + 1}</span> <span id="waypoint-list_item_label--{waypoint.id}" class="side-tab_item_label waypoint-list_item_label focusable" onclick="{handleTitleClick.bind(this,waypoint.id)}" onkeydown="{this.checkBlurKey.bind(this,waypoint.id)}" onblur="{this.editTitle.bind(this,waypoint.id)}" placeholder="Untitled waypoint">{waypoint.title}</span> <button if="{!canvas.isViewOnly()}" class="floating-menu_button side-tab_item_menu" onclick="{summonMenu}"> <i class="material-icons floating-menu_button_icon" data-id="{waypoint.id}">more_vert</i> </button> </li> </ul> </div> <footer class="side-tab_footer"> <button if="{!canvas.isViewOnly()}" ref="addWaypoint" class=" side-tab_action {cardsZeroState && \'side-tab_action--hidden\'} Button Button--Plain Button--Full " onclick="{addWaypoint}"> <svg class="Button__Icon"> <use xlink:href="#add-circle-outline-icon"></use> </svg> <span class="Button__Label">Add a slide</span> </button> </footer> </aside> <popover position="right" title="{this.emptyWaypoint && this.emptyWaypoint.title} has no cards" ref="empty-waypoint-popover" size="small" closable="{false}"> The cards in this waypoint were removed from the map. <div style="margin-top: 10px; display: flex; justify-content: space-between;"> <button class="popover_link edit-waypoint" onclick="{this.parent.editEmptyWaypointHandler}">Edit Selection</button> <button class="popover_link remove-waypoint" style="color: #acb9c8;" onclick="{this.parent.removeEmptyWaypointHandler}">Delete Slide</button> </div> </popover>',
  '',
  'class="side-tab_container"', function(opts) {
'use strict';

var _this = this;

var _sortablejs = require('sortablejs');

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

var _nodesUi = require('lib/nodes-ui');

var _util = require('lib/util');

var _constants = require('lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.waypointsTabTag = this;
this.waypoints = _waypointsUi2.default.getWaypoints();

this.cardsZeroState = _store_instance2.default.getNodesSize() === 0;
this.waypointsZeroState = this.waypoints.length === 0;
this.isOpen = false;

this.on('update', function () {
  _this.cardsZeroState = _store_instance2.default.getNodesSize() === 0;
  _this.waypointsZeroState = _waypointsUi2.default.getWaypoints().length === 0;
  _this.waypoints = _waypointsUi2.default.getWaypoints();
  canvas.waypointsTabMenu.update();
});

this.on('mount', function () {
  _waypointsUi2.default.setTab(_this);

  _this.initSortable();
  _this.listen();
});

this.cardCount = function () {
  return _waypointsUi2.default.autopopulatableNodes().length;
};

this.cardText = function () {
  if (_this.cardCount() == 1) {
    return 'card';
  }
  return 'cards';
};

this.listen = function () {
  _presentationUi2.default.on('presentation-present', function (_ref) {
    var waypointId = _ref.waypointId;

    _this.hideCursor();
    _this.deselectWaypoints({ stopPresenting: true });
    _this.selectWaypoint({
      waypointId: waypointId,
      scrollTab: true,
      presenting: true
    });
  });

  _presentationUi2.default.on('presentation-pause', function (_ref2) {
    var waypointId = _ref2.waypointId;
    var waypointsTabMenu = canvas.waypointsTabMenu;

    if (waypointsTabMenu) waypointsTabMenu.refs.resumeButton.classList.remove('hidden');
    _this.markPausedWaypoint({ waypointId: waypointId });
  });

  _presentationUi2.default.on('presentation-resume', function () {
    var waypointsTabMenu = canvas.waypointsTabMenu;

    if (waypointsTabMenu) waypointsTabMenu.refs.resumeButton.classList.add('hidden');
    _this.update();
  });

  _presentationUi2.default.on('presentation-stop', function () {
    _this.showCursor();
    _this.deselectWaypoints({ scrollTab: true, stopPresenting: true });
  });

  _this.refs['empty-waypoint-popover'].on('mouseleave', function () {
    _this.hideEmptyWaypointPopover();
  });
};

this.handleScroll = function (event) {
  return event.stopPropagation();
};

this.initSortable = function () {
  if (canvas.isViewOnly()) return;

  _this.sortable = new _sortablejs2.default(_this.refs.waypointList, {
    animation: 150,
    ghostClass: 'side-tab_item--dropzone',
    dragClass: 'side-tab_item--dragging',
    store: {
      get: function get() {
        return _waypointsUi2.default.getWaypoints();
      },
      set: function set(sortable) {
        return _this.updateWaypointOrderIndexes(sortable.toArray());
      }
    },
    onStart: function onStart() {
      _this.isSorting = true;
      _this.refs.waypointList.classList.add('waypoint-list--sorting');
      _this.hideMenu();
    },
    onEnd: function onEnd() {
      _this.isSorting = false;
      _this.refs.waypointList.classList.remove('waypoint-list--sorting');
    }
  });
};

this.instructionsShowable = function () {
  return _store_instance2.default.getNodesSize() === 0;
};

this.chooseWaypointHandler = function (_ref3) {
  var waypointId = _ref3.waypointId;

  _this.hideMenu();
  _this.chooseWaypoint({ id: waypointId });
};

this.updateWaypoints = function (waypoints) {
  Object.assign(_this, { waypoints: waypoints });
  _this.update();
};

this.markPausedWaypoint = function (_ref4) {
  var waypointId = _ref4.waypointId;

  if (waypointId == null) return;

  var el = document.getElementById('waypoint-list_item--' + waypointId);

  if (el) {
    el.classList.add('waypoint-list_item--paused');
  }
};

this.populateWaypoints = function (e) {
  e.stopPropagation();
  if (!_waypointsUi2.default.getPresentation()) {
    _waypointsUi2.default.createWaypointsPresentation();
  }
  var presentation = _waypointsUi2.default.getPresentation();
  _waypointsUi2.default.autopopulatePresentation(presentation);
  _this.updateWaypoints(presentation.getWaypoints());
};

this.highlightWaypointCandidates = function () {
  for (var _iterator = _waypointsUi2.default.autopopulatableNodes(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref5;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref5 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref5 = _i.value;
    }

    var node = _ref5;

    _nodesUi.nui.highlightCardBorders(node);
  }
};

this.unHighlightWaypointCandidates = function () {
  _nodesUi.nui.unhighlightAllCardBorders();
};

this.summonMenu = function (e) {
  e.stopPropagation();
  var currentTarget = e.currentTarget;

  var id = currentTarget.parentNode.getAttribute('data-id');

  var _currentTarget$getBou = currentTarget.getBoundingClientRect(),
      left = _currentTarget$getBou.left,
      bottom = _currentTarget$getBou.bottom;

  var waypointsTabItemMenu = canvas.waypointsTabItemMenu;

  _this.hideTopMenu();
  _this.hideEmptyWaypointPopover(id);

  if (_this.menuShowing && _this.activeMenuWaypoint == id) {
    _this.hideMenu();
  }

  Object.assign(waypointsTabItemMenu.root.style, {
    left: left + 'px',
    top: bottom + 4 + 'px'
  });

  _this.menuShowing = true;
  waypointsTabItemMenu.root.classList.remove('floating-menu--hidden');
  _this.activeMenuWaypoint = id;
};

this.hideMenu = function () {
  if (_this.menuShowing) {
    var waypointsTabItemMenu = canvas.waypointsTabItemMenu;

    _this.menuShowing = false;
    waypointsTabItemMenu.root.removeAttribute('style');
    waypointsTabItemMenu.root.classList.add('floating-menu--hidden');
  }
};

this.hideTopMenu = function () {
  if (!_this.topMenuHidden) {
    var waypointsTabMenu = canvas.waypointsTabMenu;

    waypointsTabMenu.root.classList.add('floating-menu--hidden');
  }
};

this.toggleTopMenu = function (event) {
  var waypointsTabMenu = canvas.waypointsTabMenu;
  var classList = waypointsTabMenu.root.classList;

  var _event$currentTarget$ = event.currentTarget.getBoundingClientRect(),
      left = _event$currentTarget$.left,
      bottom = _event$currentTarget$.bottom;

  var isHidden = classList.contains('floating-menu--hidden');

  event.stopPropagation();

  if (isHidden) {
    canvas.hidePopups();

    Object.assign(waypointsTabMenu.root.style, {
      left: left + 'px',
      top: bottom + 4 + 'px'
    });

    classList.remove('floating-menu--hidden');
    _this.topMenuHidden = false;
  } else {
    classList.add('floating-menu--hidden');
    _this.topMenuHidden = true;
  }
};

this.resetHighlightedState = function () {
  for (var _iterator2 = _this.root.querySelectorAll('.waypoint-list_item--selected'), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref6;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref6 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref6 = _i2.value;
    }

    var el = _ref6;

    el.classList.remove('waypoint-list_item--selected', 'waypoint-list_item--active', 'side-tab_item--selected', 'side-tab_item--active');
  }
  for (var _iterator3 = _this.root.querySelectorAll('.waypoint-list_item--paused'), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref7;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref7 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref7 = _i3.value;
    }

    var _el = _ref7;

    _el.classList.remove('waypoint-list_item--paused');
  }
};

this.chooseWaypoint = function (_ref8) {
  var id = _ref8.id;

  if (_waypointsUi2.default.selectedWaypoint && _waypointsUi2.default.selectedWaypoint == id && _presentationUi2.default.isPresenting) {
    // if editing the current waypoint, a click on sidebar takes you out of edit mode and returns to presenting
    if (_waypointsUi2.default.isEditing) {
      _waypointsUi2.default.stopEditing();
    } else {
      // otherwise a click on the sidebar row exits the presentation
      _this.deselectWaypoints({ stopPresenting: true });
      _presentationUi2.default.stop({ restorePanzoom: true });
      return;
    }
  }
  // if you were editing a different waypoint, stop editing mode
  if (_waypointsUi2.default.isEditing) {
    _waypointsUi2.default.stopEditing();
  }
  canvas.clearSelectedElements();
  var waypoints = _waypointsUi2.default.getWaypoints();
  var index = waypoints.findIndex(function (w) {
    return w.id == id;
  });
  _this.resetHighlightedState();

  _presentationUi2.default.start({
    startingIndex: index,
    slides: waypoints
  });
};

this.resumePresentation = function () {
  if (_presentationUi2.default.isPaused()) {
    _this.hideTopMenu();
    _this.resetHighlightedState();
    _presentationUi2.default.resume();
  } else {
    _this.startPresentation();
  }
};

this.startPresentation = function () {
  _this.hideTopMenu();
  _this.resetHighlightedState();
  _presentationUi2.default.start({
    startingIndex: 0,
    slides: _waypointsUi2.default.getWaypoints()
  });
};

this.selectWaypointHandler = function (waypointId, e) {

  if (!_this.isSorting) {
    var waypoint = _store_instance2.default.getPresentation().getWaypoint({ id: waypointId });
    _presentationUi2.default.highlightNodes(waypoint.getNodeIds(), false);
  }

  if (!_this.isSorting && !_presentationUi2.default.isPresenting) {
    _this.selectWaypoint({ waypointId: waypointId });
  }
};

this.deselectWaypointsHandler = function (waypointId, e) {
  if (e && e.relatedTarget && !e.relatedTarget.classList.contains('popover')) {
    _this.hideEmptyWaypointPopover(waypointId);
  }
  if (!_presentationUi2.default.isPresenting) {
    _this.deselectWaypoints();
  } else {
    _presentationUi2.default.unhighlightNodes();
  }
};

this.selectWaypoint = function (_ref9) {
  var waypointId = _ref9.waypointId,
      scrollTab = _ref9.scrollTab,
      presenting = _ref9.presenting;

  var waypoint = _store_instance2.default.getPresentation().getWaypoint({ id: waypointId });

  if (!waypoint.getNodeIds().length && !canvas.isViewOnly()) {
    var referenceEl = _this.root.querySelector('li[data-id="' + waypointId + '"]');
    _this.summonEmptyWaypointPopover({ referenceEl: referenceEl, waypointId: waypointId });
  }

  _waypointsUi2.default.selectWaypoint({ waypointId: waypointId, scrollTab: scrollTab, presenting: presenting });
};

this.deselectWaypoints = function () {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      scrollTab = _ref10.scrollTab,
      stopPresenting = _ref10.stopPresenting;

  if (!_this.isSorting) {
    var selectedWaypoint = _waypointsUi2.default.selectedWaypoint;

    if (selectedWaypoint) {
      _presentationUi2.default.unhighlightNodes();
      _waypointsUi2.default.deselectWaypoints({ scrollTab: scrollTab, stopPresenting: stopPresenting });
    }
  }
};

this.updateWaypointOrderIndexes = function (ids) {
  _waypointsUi2.default.updateWaypointOrderIndexes(ids.map(function (id, index) {
    return {
      id: id,
      orderIndex: index + 1
    };
  }));
};

this.addWaypoint = function () {
  var nodes = canvas.getSelectedNodes();

  if (nodes && nodes.length) {
    _waypointsUi2.default.addWaypoint({
      nodeIds: nodes.map(function (n) {
        return n.id;
      }),
      title: nodes[0].title
    });

    canvas.clearSelectedElements();

    _this.update();
  } else {
    if (_presentationUi2.default.isPresenting) {
      _presentationUi2.default.pause();
    }
    _waypointsUi2.default.startAdding();
  }
};

this.editWaypoint = function () {
  _waypointsUi2.default.startEditing({ id: _this.activeMenuWaypoint });
  _this.hideMenu();
};

this.removeWaypoint = function () {
  _waypointsUi2.default.removeWaypoint({ id: _this.activeMenuWaypoint });
  _this.hideMenu();
};

this.clearWaypoints = function () {
  _presentationUi2.default.stop({ restorePanzoom: true });
  _waypointsUi2.default.clearWaypoints();
  _this.hideTopMenu();
};

this.showAddButton = function () {
  var addWaypoint = _this.refs.addWaypoint;

  addWaypoint.classList.remove('side-tab_action--hidden');
};

this.hideAddButton = function () {
  var addWaypoint = _this.refs.addWaypoint;

  addWaypoint.classList.add('side-tab_action--hidden');
};

this.openWaypointsHelp = function (event) {
  event.stopPropagation();
  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('waypoints');
};

this.showCursor = function () {
  var waypointList = _this.refs.waypointList;

  if (waypointList) waypointList.classList.remove('waypoint-list--presenting');
};

this.hideCursor = function () {
  var waypointList = _this.refs.waypointList;

  if (waypointList) waypointList.classList.add('waypoint-list--presenting');
};

this.handleTitleDoubleClick = function (waypointId, e) {
  e.stopPropagation();
  _this.activeMenuWaypoint = waypointId;
  _this.startEditingTitle(e);
};

this.handleTitleClick = function (waypointId, e) {
  if (_this.editing == waypointId) {
    e.stopPropagation();
  }
};

this.checkBlurKey = function (waypointId, e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode == ENTER) {
    e.preventDefault();
    window.getSelection().empty();
    _this.editTitle(waypointId, e);
    canvas.hidePopups();
  } else if (e.keyCode == ESCAPE) {
    e.preventDefault();
    window.getSelection().empty();
    _this.revertTitle(waypointId);
    canvas.hidePopups();
  }
};

this.revertTitle = function (waypointId) {
  var oldTitle = _waypointsUi2.default.getWaypoint({ id: waypointId }).title;
  var titleElement = _this.getWaypointTitleElement(waypointId);
  titleElement.innerText = oldTitle;
  _this.stopEditingTitle();
  _this.update();
};

this.editTitle = function (waypointId, e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  var titleElement = _this.getWaypointTitleElement(waypointId);
  var waypoint = _waypointsUi2.default.getWaypoint({ id: waypointId });
  var title = titleElement.innerText;
  _waypointsUi2.default.editWaypointTitle({ waypoint: waypoint, title: title });
  titleElement.blur();

  _this.stopEditingTitle();
  _this.update();
  titleElement.innerText = title; // prevents text from showing up duplicated after riot update
};

this.getWaypointRow = function (waypointId) {
  return document.querySelector('#waypoint-list_item--' + waypointId);
};

this.getWaypointTitleElement = function (waypointId) {
  return document.querySelector('#waypoint-list_item_label--' + waypointId);
};

this.startEditingTitle = function (e) {
  e.stopPropagation();
  _this.hideMenu();
  _this.stopEditingTitle(); // if editing a different title, stop editing that one before editing this one
  var waypointLabelElement = _this.getWaypointTitleElement(_this.activeMenuWaypoint);
  var waypointRowElement = _this.getWaypointRow(_this.activeMenuWaypoint);
  waypointLabelElement.contentEditable = true;
  waypointLabelElement.focus();
  (0, _util.selectElementContents)(waypointLabelElement);
  waypointRowElement.classList.add('editing');
  _this.editing = _this.activeMenuWaypoint;
  _this.editingLabelElement = waypointLabelElement;
  _this.editingRow = waypointRowElement;
  waypointLabelElement.addEventListener('dblclick', _this.stopPropagation);
};

this.stopEditingTitle = function () {
  if (!_this.editing) {
    return;
  }
  if (_this.editingLabelElement) {
    _this.editingLabelElement.contentEditable = false;
    _this.editingLabelElement.removeEventListener('dblclick', _this.stopPropagation);
  }
  if (_this.editingRow) {
    _this.editingRow.classList.remove('editing');
  }

  _this.editing = null;
  _this.editingLabelElement = null;
  _this.editingRow = null;
  _this.unsetActiveWaypoint();
};

this.editEmptyWaypointHandler = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  _this.hideMenu();
  if (_this.emptyWaypoint) {
    _waypointsUi2.default.startEditing({ id: _this.emptyWaypoint.id });
  }
  _this.hideEmptyWaypointPopover();
};

this.removeEmptyWaypointHandler = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  _this.hideMenu();
  if (_this.emptyWaypoint) {
    _waypointsUi2.default.removeWaypoint({ id: _this.emptyWaypoint.id });
  }
  _this.hideEmptyWaypointPopover();
};

this.summonEmptyWaypointPopover = function (_ref11) {
  var referenceEl = _ref11.referenceEl,
      waypointId = _ref11.waypointId;

  if (_this.menuShowing) {
    return;
  }
  var waypoint = _waypointsUi2.default.getWaypoint({ id: waypointId });
  if (!waypoint) {
    return;
  }

  var referenceRect = referenceEl.getBoundingClientRect();
  var rootRect = _this.root.getBoundingClientRect();
  _this.emptyWaypoint = waypoint;

  var ref = _this.refs['empty-waypoint-popover'];
  if (ref && ref.refs.main) {
    ref.refs.main.style.top = referenceRect.top - rootRect.top - 4 + 'px';
    ref.refs.main.style.left = referenceRect.right - 4 + 'px';
    ref.show();
    ref.update();
  }
};

this.hideEmptyWaypointPopover = function () {
  _this.emptyWaypoint = null;
  var ref = _this.refs['empty-waypoint-popover'];
  if (ref) {
    ref.hide();
  }
};

this.stopPropagation = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.unsetActiveWaypoint = function () {
  _this.activeMenuWaypoint = null;
};

this.scrollToEnd = function () {
  var el = _this.refs.scrollList;
  el.scrollTop = el.scrollHeight - el.clientHeight;
};

// update the number of cards available to add to the presentation
this.refreshIfNeeded = function () {
  if (!_this.isOpen) return;
  if (!_this.waypointsZeroState) return;
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('waypoints-tab')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/waypoints-tab.html
// module id = 668
// module chunks = 0